import React, { Component } from 'react';
import { connect } from 'react-redux';
import {NavControl} from 'modules/navigation/NavBarContainer'


import {addLeaderboard, clearLeaderboardRecords} from 'actions/leaderboards.js';
import LeaderboardContainer from './LeaderboardContainer.js';
import TeamLeaderboardContainer from './TeamLeaderboardContainer.js';

class LeaderboardSelectorContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {selectedTeamLeaderboard:null};
        this.onClickRecord = this.onClickRecord.bind(this);
        this.onClose = this.onClose.bind(this);
    }

    componentWillUnmount() {
        this.props.dispatch(clearLeaderboardRecords());
    }

    onClickRecord(record) {
        var leaderboard = record && record.team && record.team.leaderboard;
        if(leaderboard) {
            //For some reason GET leaderboards/id doesn't work for team leaderboards
            //Therefore this won't work: this.props.history.push('/leaderboards/' + record.team.leaderboard.id);
  
            //Create a pseudo-index. This will 
            //  1) prevent collision with actual leaderboards 
            //  2) ensure uniqueness - each record.team.leaderboard appears to have the same id but different contents, possibly due to it being generated on the fly in the back end.
            leaderboard = {...leaderboard, 
                           id:(leaderboard.id+'/'+leaderboard.teamId), 
                            teamInfo:{rank:record.rank, avatar:(record.team.avatar||{}), title:record.team.name, points:record.points}};
 
            //ensure team leaderboard is in redux store
            this.props.dispatch(addLeaderboard(leaderboard));
            this.setState({selectedTeamLeaderboard:leaderboard});
        }
    }

    onClose() {
        this.setState({selectedTeamLeaderboard:null});
    }

    renderTeamLeaderboard() {
        return (
            <NavControl closeIconOpts={{key:'1', name:'chevron left'}} onClose={this.onClose}>
                <TeamLeaderboardContainer
                    leaderboard={this.state.selectedTeamLeaderboard} />
            </NavControl>
        );
    }

    renderLeaderboard() {
        return <LeaderboardContainer {...this.props} onClickRecord={this.onClickRecord} />
    }
    

    render() {
        if(this.state.selectedTeamLeaderboard) {
            return this.renderTeamLeaderboard();
        } else {
            return this.renderLeaderboard();
        }
    }
}

export default connect()(LeaderboardSelectorContainer);



// WEBPACK FOOTER //
// ./src/modules/leaderboards/LeaderboardSelectorContainer.js